import React, { useEffect, useState } from 'react';
import { FiPlusCircle, FiX } from 'react-icons/fi';
import Select from 'react-select';

export default function QuizReportFilter(props) {
  const { data, setSelectedExams, setSelectedBooklets, currentFilters, handleRemoveFilterItem } = props;
  const [show, setShow] = useState(false);
  const [showSelect, setShowSelect] = useState(false);
  const [currentFilterIndex, setCurrentFilterIndex] = useState(null);

  const handleChange = async e => {
    //adicionar itens no filtro
    if (data[currentFilterIndex].name === 'Prova') {
      setSelectedExams(prevState => [...prevState, { value: e.value, label: e.label, type: 'exam' }]);
    }
    if (data[currentFilterIndex].name === 'Avaliação') {
      setSelectedBooklets(prevState => [...prevState, { value: e.value, label: e.label, type: 'booklet' }]);
    }
    setShowSelect(false);
  };

  return (
    <div
      className={show ? 'report-filter report-filter--is-open' : 'report-filter'}
      onClick={() => setShow(!show)}
    >
      <div className="report-filter__inner">
        <button
          type="button"
          className="report-filter__toggle"
          onClick={() => setShowSelect(false)}
        >
          <FiPlusCircle /> Adicionar filtro
        </button>

        {show && (
          <div
            className="report-filter__options"
            onClick={() => setShowSelect(true)}
          >
            {data?.map((btn, i) => (
              <button
                type="button"
                className="report-filter__btn"
                onClick={() => setCurrentFilterIndex(i)}
                key={i}
              >
                {btn.name}
              </button>
            ))}
          </div>
        )}
      </div>

      {showSelect && (
        <div
          className="report-filter__select"
          onClick={e => e.stopPropagation()}
        >
          <Select
            openMenuOnFocus
            options={data[currentFilterIndex]?.options?.map(item => {
              return { value: item?.value, label: item?.label };
            })}
            className="react-multi-select report-form__select"
            classNamePrefix="react-multi-select"
            placeholder={data[currentFilterIndex]?.placeholder}
            noOptionsMessage={() => 'Sem opções'}
            components={{
              IndicatorSeparator: () => null,
              ClearIndicator: () => null
            }}
            onChange={handleChange}
          />
        </div>
      )}
      {currentFilters?.length > 0 && (
        <div
          className="report-filter__value-container"
          onClick={e => e.stopPropagation()}
        >
          {currentFilters?.map(badge => (
            <span
              className="report-filter__badge"
              key={badge?.value}
            >
              {badge?.label}{' '}
              <FiX
                className="report-filter__badge-icon"
                onClick={() => handleRemoveFilterItem(badge)}
              />
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
